import 'globals';
import { Dropdown } from "bootstrap";

window.PageLoadedQueue.addFunction(function() {
    const dropdownElementList = document.querySelectorAll('.dropdown');

    if (dropdownElementList.length) {
        dropdownElementList.forEach((dropdown) => {
            const dropdownToggle = dropdown.querySelector('.dropdown-toggle');

            if (dropdownToggle) {
                const bootstrapDropdown = Dropdown.getOrCreateInstance(dropdownToggle);

                dropdown.addEventListener('mouseout', () => {
                    bootstrapDropdown.hide();
                }, false);

                dropdown.addEventListener('mouseover', () => {
                    bootstrapDropdown.show();
                }, false);

                dropdown.addEventListener('click', () => {
                    bootstrapDropdown.show();
                }, false);
            }
        });
    }
});
